import React from "react";
import ReactDom from "react-dom";
import { motion, AnimatePresence } from "framer-motion";

const modalOverlayVariants = {
  hidden: {
    opacity: 0,
  },
  visible: {
    opacity: 1,
  },
  exit: {
    opacity: 0,
    transition: { ease: "easeInOut" },
  },
};

const modalVariants = {
  hidden: {
    scale: 0,
  },
  visible: {
    scale: 1,
  },
  exit: {
    scale: 0,
    transition: { ease: "easeInOut" },
  },
};

const Modal = ({
  open,
  w = "96",
  h = "64",
  bgColor = "white",
  others = "",
  children,
}) => {
  return ReactDom.createPortal(
    <>
      <AnimatePresence>
        {open && (
          <motion.div
            className="fixed top-0 left-0 right-0 bottom-0 bg-black bg-opacity-30 z-1000"
            variants={modalOverlayVariants}
            initial="hidden"
            animate="visible"
            exit="exit"
          >
            <div
              style={{
                position: "fixed",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                zIndex: 2000,
              }}
            >
              <motion.div
                className={`min-h-64 w-${w} h-${h} bg-${bgColor} ${others} p-5 rounded-lg`}
                variants={modalVariants}
                initial="hidden"
                animate="visible"
                exit="exit"
              >
                {children}
              </motion.div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>,
    document.getElementById("portal")
  );
};

export default Modal;
